import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "../redux/default/reducer";
import Filters from "../components/filters";
import { selectDefaultReducer } from "../redux/default/selectors";

const FiltersContainer = () => {
  const dispatch = useDispatch();

  const { 
    filters, 
    blockingUI, 
    translations 
  } = useSelector(selectDefaultReducer);

  const onMinInputChange = (key, value) => {
    dispatch(Action.minInputChanged({ key, value }));
    dispatch(Action.fetchFilterState());
  };

  const onMaxInputChange = (key, value) => {
    dispatch(Action.maxInputChanged({ key, value }));
    dispatch(Action.fetchFilterState());
  };

  const onSelectChange = (key, selectedOptions) => {
    const values = selectedOptions.map(option => option.value);
    dispatch(Action.selectFilterChanged({ key, values }));
    dispatch(Action.fetchFilterState());
  };

  const onResetFiltersClick = () => {
    dispatch(Action.resetFilters());
    dispatch(Action.fetchFilterState());
  };

  return (
    <Filters
      filters={filters}
      blockingUI={blockingUI}
      translations={translations}
      onMinInputChange={onMinInputChange}
      onMaxInputChange={onMaxInputChange}
      onSelectChange={onSelectChange}
      onResetFiltersClick={onResetFiltersClick}
    />
  );
};

export default FiltersContainer;